const Constants = {
    BASE_URL: "http://affiliates.more-apps.ru/api/"
}
export default Constants
